<template>
  <Text :text="label"><RequiredChar v-if="required" /></Text>
  <slot>
    <Text :text="value"></Text>
  </slot>
</template>

<script setup>
import RequiredChar from "@/components/UI/Typography/RequiredChar.vue";
import Text from "../Typography/Text.vue";

defineProps({
  label: {
    type: String,
  },
  value: {
    type: String,
  },
  required: {
    type: Boolean,
  },
});
</script>
